import React, { memo } from 'react';

import HtmlContentFromApi from '@r1-frontend/ui-react/components/HtmlContentFromApi';

import { ButtonElement, IButtonProps } from './components/ButtonElement';
import { IImageProps, ImageElement } from './components/ImageElement';

import * as ST from './styled';

export interface TariffElementProps {
    title?: string,
    titleText?: string,
    imageProps: IImageProps,
    btnProps?: IButtonProps,
}

export const TariffElement = (item: TariffElementProps): JSX.Element => {
    const {
        title,
        titleText,
        imageProps,
        btnProps,
    } = item;

    return (
        <ST.TariffElement>
            <ST.RowWrap>
                <ST.DescriptionWrap>
                    <ImageElement
                        {...imageProps}
                    />

                    <ST.TitleWrap>
                        <ST.Title>{title}</ST.Title>

                        {titleText &&
                            <ST.DesktopOnlyWrap data-test='desktop-wrap'>
                                <ST.Description>
                                    <HtmlContentFromApi>
                                        {titleText}
                                    </HtmlContentFromApi>
                                </ST.Description>
                            </ST.DesktopOnlyWrap>
                        }
                    </ST.TitleWrap>
                </ST.DescriptionWrap>

                <ButtonElement
                    {...btnProps}
                />
            </ST.RowWrap>

            {titleText &&
                <ST.MobileOnlyWrap data-test='mobile-wrap'>
                    <ST.Description>
                        <HtmlContentFromApi>
                            {titleText}
                        </HtmlContentFromApi>
                    </ST.Description>
                </ST.MobileOnlyWrap>
            }
        </ST.TariffElement>
    );
};

export default memo(TariffElement);
